module.exports = __webpack_public_path__ + "static/media/souse.9b9a10fc.png";